import { render, staticRenderFns } from "./ConstructionDetailModal.vue?vue&type=template&id=64d306ce"
import script from "./ConstructionDetailModal.vue?vue&type=script&lang=js"
export * from "./ConstructionDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports